<template>
  <rect y="4" width="4" height="8" rx="1" fill="#3769D6" />
  <rect x="6" y="4" width="4" height="8" rx="1" fill="#3769D6" />
  <rect x="12" y="4" width="4" height="8" rx="1" fill="#3769D6" />
  <path
    opacity="0.5"
    d="M2 12V14C2 14.5523 2.44772 15 3 15H7C7.55228 15 8 14.5523 8 14V12"
    stroke="#3769D6"
    stroke-width="2"
  />
  <path
    opacity="0.5"
    d="M8 4V2C8 1.44772 8.44772 1 9 1H13C13.5523 1 14 1.44772 14 2V4"
    stroke="#3769D6"
    stroke-width="2"
  />
</template>
